import { withModifiers as _withModifiers, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, resolveDirective as _resolveDirective } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "fixed top-0 right-0 left-0 bottom-0 flex justify-center items-center bg-black bg-opacity-50 z-[999] max-w-[600px] max-h-[1000px] m-auto"
}
const _hoisted_2 = {
  key: 0,
  class: "w-full h-full absolute story-overlay"
}
const _hoisted_3 = { class: "absolute bottom-8 space-y-6 px-9 z-10 left-0 w-full" }
const _hoisted_4 = {
  key: 0,
  class: "text-2xl text-white font-medium whitespace-pre-line"
}
const _hoisted_5 = {
  key: 1,
  class: "text-white text-lg whitespace-pre-line"
}
const _hoisted_6 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ButtonComponent = _resolveComponent("ButtonComponent")!
  const _directive_auto_animate = _resolveDirective("auto-animate")!

  return _withDirectives((_openBlock(), _createElementBlock("div", null, [
    (_ctx.isActive && _ctx.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", {
            class: "top-0 right-0 left-0 bottom-0 fixed h-screen bg-grey bg-opacity-40",
            style: {"z-index":"-1"},
            onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.$emit('end')), ["stop"]))
          }),
          _createElementVNode("div", {
            class: _normalizeClass(["absolute left-0 right-0 flex h-[2px] rounded-full px-4 z-[1]", 
          _ctx.platform === 'web' || _ctx.platform === 'android' || _ctx.platform === 'pwa'
            ? 'top-5'
            : 'top-14'
        ])
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.story.slides, (slide, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: _normalizeClass(["h-full mr-1 rounded-full", _ctx.story.progressColor || 'bg-white']),
                style: _normalizeStyle({
            width:
              index <= _ctx.activeSlideIndex
                ? `${100 / _ctx.story.slides.length}%`
                : '0%',
          })
              }, null, 6))
            }), 128))
          ], 2),
          _createElementVNode("div", {
            onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.$emit('end')), ["prevent","stop"])),
            class: _normalizeClass(["absolute right-4 h-8 w-8 flex items-center justify-center text-xl bg-white text-gray-400 rounded-full px-4 z-10", 
          _ctx.platform === 'web' || _ctx.platform === 'android' || _ctx.platform === 'pwa'
            ? 'top-8'
            : 'top-20'
        ])
          }, [...(_cache[4] || (_cache[4] = [
            _createElementVNode("i", { class: "fas fa-times" }, null, -1)
          ]))], 2),
          (
          _ctx.currentSlide?.title ||
          _ctx.currentSlide?.description ||
          _ctx.currentSlide?.buttonText
        )
            ? (_openBlock(), _createElementBlock("div", _hoisted_2))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_3, [
            (_ctx.currentSlide?.title)
              ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(_ctx.currentSlide.title), 1))
              : _createCommentVNode("", true),
            (_ctx.currentSlide?.description)
              ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(_ctx.currentSlide.description), 1))
              : _createCommentVNode("", true),
            (_ctx.currentSlide?.buttonText)
              ? (_openBlock(), _createBlock(_component_ButtonComponent, {
                  key: 2,
                  title: _ctx.currentSlide.buttonText,
                  class: "text-grey font-medium",
                  color: _ctx.currentSlide?.buttonColor || 'primary',
                  onClickAction: _ctx.handleButtonAction,
                  textColor: _ctx.currentSlide?.buttonTextColor || ''
                }, null, 8, ["title", "color", "onClickAction", "textColor"]))
              : _createCommentVNode("", true)
          ]),
          (!_ctx.isBackground)
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.story.slides, (slide, index) => {
                return _withDirectives((_openBlock(), _createElementBlock("img", {
                  src: _ctx.imageCache.get(slide.image as string),
                  key: slide.image,
                  class: "max-w-full w-full h-full object-cover"
                }, null, 8, _hoisted_6)), [
                  [_vShow, _ctx.activeSlideIndex === index]
                ])
              }), 128))
            : _createCommentVNode("", true),
          (_ctx.isBackground)
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(_ctx.story.slides, (slide, index) => {
                return _withDirectives((_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: _normalizeClass([
            slide.background,
            'h-full w-full max-w-full absolute top-0 right-0 left-0 bottom-0',
          ])
                }, null, 2)), [
                  [_vShow, _ctx.activeSlideIndex === index]
                ])
              }), 128))
            : _createCommentVNode("", true),
          _createElementVNode("div", {
            class: "w-1/2 h-full absolute left-0 cursor-pointer z-1",
            onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.previousSlide && _ctx.previousSlide(...args)), ["stop"]))
          }),
          _createElementVNode("div", {
            class: "w-1/2 h-full absolute right-0 cursor-pointer z-1",
            onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.nextSlide(true)), ["stop"]))
          })
        ]))
      : _createCommentVNode("", true)
  ])), [
    [_directive_auto_animate, { duration: 150 }]
  ])
}